<template>
  <span v-html="value.content" :key="value.key"></span>
</template>

<script>
export default {
  name: 'htmlTd',
  props: ['value'],
};
</script>
